import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root',
})
export class ErpService {
  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }
  constructor(private http: HttpClient) {}

  getPlantMappingIUCD(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'ERP/PlantMapping_IU',
      data
    );
  }

  getMahcineMappingIUCD(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'ERP/MachineMapping_IU',
      data
    );
  }
  getProductDetails(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'ERP/GetProductionPlan',
      data
    );
  }
  getproductionPODyFields(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'ERP/GetPODyFields', data);
  }
  GetOperation(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'ERP/GetOperation', data);
  }

  GetBOM(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'ERP/GetBOM', data);
  }
}
